<ng-container *ngrxLet="entity | get : props.path as entityDate">
  <ng-container *ngIf="entityDate; else noDateTmpl">
    <ng-container [ngSwitch]="props.format">
      <ng-container *ngSwitchCase="formats.TO_NOW">
        {{
          entityDate
            | toLocalTime
            | dfnsFormatDistanceToNow : { addSuffix: true }
        }}
      </ng-container>
      <ng-container *ngSwitchDefault> {{ entityDate | date }} </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #noDateTmpl>-</ng-template>
